const Currencies = [
    {
    "code":"AFN",
    "symbol":"Af"
    },
    {
    "code":"EUR",
    "symbol":"€"
    },
    {
    "code":"ALL",
    "symbol":"ALL"
    },
    {
    "code":"DZD",
    "symbol":"DA"
    },
    {
    "code":"USD",
    "symbol":"$"
    },
    {
    "code":"ARS",
    "symbol":"AR$"
    },
    {
    "code":"AMD",
    "symbol":"AMD"
    },
    {
    "code":"AUD",
    "symbol":"AU$"
    },
    {
    "code":"AZN",
    "symbol":"man."
    },
    {
    "code":"BHD",
    "symbol":"BD"
    },
    {
    "code":"BDT",
    "symbol":"Tk"
    },
    {
    "code":"BZD",
    "symbol":"BZ$"
    },
    {
    "code":"XOF",
    "symbol":"CFA"
    },
    {
    "code":"BOB",
    "symbol":"Bs"
    },
    {
    "code":"BAM",
    "symbol":"KM"
    },
    {
    "code":"BWP",
    "symbol":"BWP"
    },
    {
    "code":"NOK",
    "symbol":"Nkr"
    },
    {
    "code":"BRL",
    "symbol":"R$"
    },
    {
    "code":"BND",
    "symbol":"BN$"
    },
    {
    "code":"BGN",
    "symbol":"BGN"
    },
    {
    "code":"BIF",
    "symbol":"FBu"
    },
    {
    "code":"KHR",
    "symbol":"KHR"
    },
    {
    "code":"XAF",
    "symbol":"FCFA"
    },
    {
    "code":"CAD",
    "symbol":"CA$"
    },
    {
    "code":"CVE",
    "symbol":"CV$"
    },
    {
    "code":"CLP",
    "symbol":"CL$"
    },
    {
    "code":"CNY",
    "symbol":"CN¥"
    },
    {
    "code":"COP",
    "symbol":"CO$"
    },
    {
    "code":"KMF",
    "symbol":"CF"
    },
    {
    "code":"CDF",
    "symbol":"CDF"
    },
    {
    "code":"NZD",
    "symbol":"NZ$"
    },
    {
    "code":"CRC",
    "symbol":"₡"
    },
    {
    "code":"HRK",
    "symbol":"kn"
    },
    {
    "code":"CZK",
    "symbol":"Kč"
    },
    {
    "code":"DKK",
    "symbol":"Dkr"
    },
    {
    "code":"DJF",
    "symbol":"Fdj"
    },
    {
    "code":"DOP",
    "symbol":"RD$"
    },
    {
    "code":"EGP",
    "symbol":"EGP"
    },
    {
    "code":"ERN",
    "symbol":"Nfk"
    },
    {
    "code":"ETB",
    "symbol":"Br"
    },
    {
    "code":"GEL",
    "symbol":"GEL"
    },
    {
    "code":"GHS",
    "symbol":"GH₵"
    },
    {
    "code":"GTQ",
    "symbol":"GTQ"
    },
    {
    "code":"GBP",
    "symbol":"£"
    },
    {
    "code":"GNF",
    "symbol":"FG"
    },
    {
    "code":"HNL",
    "symbol":"HNL"
    },
    {
    "code":"HKD",
    "symbol":"HK$"
    },
    {
    "code":"HUF",
    "symbol":"Ft"
    },
    {
    "code":"ISK",
    "symbol":"Ikr"
    },
    {
    "code":"INR",
    "symbol":"Rs"
    },
    {
    "code":"IDR",
    "symbol":"Rp"
    },
    {
    "code":"IRR",
    "symbol":"IRR"
    },
    {
    "code":"IQD",
    "symbol":"IQD"
    },
    {
    "code":"ILS",
    "symbol":"₪"
    },
    {
    "code":"JMD",
    "symbol":"J$"
    },
    {
    "code":"JPY",
    "symbol":"¥"
    },
    {
    "code":"JOD",
    "symbol":"JD"
    },
    {
    "code":"KZT",
    "symbol":"KZT"
    },
    {
    "code":"KES",
    "symbol":"Ksh"
    },
    {
    "code":"KRW",
    "symbol":"₩"
    },
    {
    "code":"KWD",
    "symbol":"KD"
    },
    {
    "code":"LBP",
    "symbol":"LB£"
    },
    {
    "code":"LYD",
    "symbol":"LD"
    },
    {
    "code":"CHF",
    "symbol":"CHF"
    },
    {
    "code":"MOP",
    "symbol":"MOP$"
    },
    {
    "code":"MKD",
    "symbol":"MKD"
    },
    {
    "code":"MGA",
    "symbol":"MGA"
    },
    {
    "code":"MYR",
    "symbol":"RM"
    },
    {
    "code":"MUR",
    "symbol":"MURs"
    },
    {
    "code":"MXN",
    "symbol":"MX$"
    },
    {
    "code":"MDL",
    "symbol":"MDL"
    },
    {
    "code":"MAD",
    "symbol":"MAD"
    },
    {
    "code":"MZN",
    "symbol":"MTn"
    },
    {
    "code":"MMK",
    "symbol":"MMK"
    },
    {
    "code":"NAD",
    "symbol":"N$"
    },
    {
    "code":"NPR",
    "symbol":"NPRs"
    },
    {
    "code":"NIO",
    "symbol":"C$"
    },
    {
    "code":"NGN",
    "symbol":"₦"
    },
    {
    "code":"OMR",
    "symbol":"OMR"
    },
    {
    "code":"PKR",
    "symbol":"PKRs"
    },
    {
    "code":"PAB",
    "symbol":"B/."
    },
    {
    "code":"PYG",
    "symbol":"₲"
    },
    {
    "code":"PEN",
    "symbol":"S/."
    },
    {
    "code":"PHP",
    "symbol":"₱"
    },
    {
    "code":"PLN",
    "symbol":"zł"
    },
    {
    "code":"QAR",
    "symbol":"QR"
    },
    {
    "code":"RON",
    "symbol":"RON"
    },
    {
    "code":"RUB",
    "symbol":"RUB"
    },
    {
    "code":"RWF",
    "symbol":"RWF"
    },
    {
    "code":"SAR",
    "symbol":"SR"
    },
    {
    "code":"RSD",
    "symbol":"din."
    },
    {
    "code":"SGD",
    "symbol":"S$"
    },
    {
    "code":"SOS",
    "symbol":"Ssh"
    },
    {
    "code":"ZAR",
    "symbol":"R"
    },
    {
    "code":"LKR",
    "symbol":"SLRs"
    },
    {
    "code":"SDG",
    "symbol":"SDG"
    },
    {
    "code":"SEK",
    "symbol":"Skr"
    },
    {
    "code":"SYP",
    "symbol":"SY£"
    },
    {
    "code":"TWD",
    "symbol":"NT$"
    },
    {
    "code":"TZS",
    "symbol":"TSh"
    },
    {
    "code":"THB",
    "symbol":"฿"
    },
    {
    "code":"TOP",
    "symbol":"T$"
    },
    {
    "code":"TTD",
    "symbol":"TT$"
    },
    {
    "code":"TND",
    "symbol":"DT"
    },
    {
    "code":"TRY",
    "symbol":"TL"
    },
    {
    "code":"UGX",
    "symbol":"USh"
    },
    {
    "code":"UAH",
    "symbol":"₴"
    },
    {
    "code":"AED",
    "symbol":"AED"
    },
    {
    "code":"UYU",
    "symbol":"$U"
    },
    {
    "code":"UZS",
    "symbol":"UZS"
    },
    {
    "code":"VEF",
    "symbol":"Bs.F."
    },
    {
    "code":"VND",
    "symbol":"₫"
    },
    {
    "code":"YER",
    "symbol":"YR"
    },
    {
    "code":"ZWL",
    "symbol":"ZWL$"
    }
]

export default Currencies